import { List, fromJS } from 'immutable';
import * as actions from '../utils/Constants'

export default (state = getInitialState(), action) => {
    switch (action.type) {
        case actions.GET_COURSES + actions.FULFILLED:
            {
                return action.payload;
            }
        case actions.TOGGLE_COURSE_SECTION_VISABILITY:
            {
                return setSectionVisibility(parseInt(action.payload, 10), state);
            }
        default:
            return state;
    }
}

const setSectionVisibility = (id, sections) => {
    return sections.map(section => {

        if (section.get('courseId') === id)
            return section.set('showSections', !section.get('showSections'));
        else if (section.get('sections').size > 0)
            return section.set('sections', setSectionVisibility(id, section.get('sections')));

        return section;

    });
}

const getInitialState = () => {
    return List();
}